/* Potato & Co. floating button cleanup
 * 1. Hides the Smile rewards launcher everywhere (Rewards now lives in the menu and footer).
 * 2. Hides chat and any remaining floating widgets while the cart page or cart drawer is open,
 *    so nothing covers Check out.
 */
(function () {
  'use strict';
  if (window.potatoFloatingButtonsLoaded) return;
  window.potatoFloatingButtonsLoaded = true;

  var style = document.createElement('style');
  style.textContent =
    '.smile-launcher-frame-container,#smile-ui-lite-launcher-frame,#smile-launcher-frame,.smile-launcher-frame,[id^="smile-"][id*="launcher"]{display:none!important}' +
    'html.potato-cart-open #shopify-chat,html.potato-cart-open inbox-online-store-chat,html.potato-cart-open .jdgm-popup-widget{display:none!important}';
  document.head.appendChild(style);

  var onCartPage = /\/cart\/?$/.test(location.pathname);

  function drawerIsOpen() {
    var drawer = document.getElementById('ecxCartDrawer');
    if (!drawer || drawer.hidden) return false;
    var css = getComputedStyle(drawer);
    return css.display !== 'none' && css.visibility !== 'hidden' && parseFloat(css.opacity) > 0;
  }

  function update() {
    document.documentElement.classList.toggle('potato-cart-open', onCartPage || drawerIsOpen());
  }

  function init() {
    update();
    var drawer = document.getElementById('ecxCartDrawer');
    if (!drawer) return;
    new MutationObserver(function () {
      update();
      setTimeout(update, 400);
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'style'] });
    drawer.addEventListener('transitionend', update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
